import './beneficiaries.scss';

import { ReactComponent as Add } from '@basqet-dashboard/common/assets/icons/add.svg';
import { Button } from '@basqet-dashboard/common/components';
import { PERMISSIONS } from '@basqet-dashboard/common/config';
import { useHasPermission } from '@basqet-dashboard/common/hooks';
import { useFetchBeneficiaries } from '@hooks/queries';
import { BulkBeneficiaryModal, SingleBeneficiaryModal } from '@pages/beneficiary';
import React, { useState } from 'react';
import { useParams } from 'react-router';

import { BulkBeneficiaries } from './bulk-beneficiaries';
import { SingleBeneficiaries } from './single-beneficiaries';

function BeneficiariesSettingsPage() {
  const { type } = useParams();

  const [beneficiaryModal, setModalBeneficiaryModal] = useState(null);

  const IS_SINGLE_BENEFICIARY = beneficiaryModal === 'SINGLE';
  const IS_BULK_BENEFICIARY = beneficiaryModal === 'BULK';

  const IS_SINGLE_BENEFICIARY_PAGE = !type || type === 'single';
  const IS_BULK_BENEFICIARY_PAGE = type === 'bulk';

  const hasPermission = useHasPermission();
  const canManageBeneficiary = hasPermission(PERMISSIONS.BENEFICIARIES_MANAGE);

  const { refetch: refetchBeneficiaries } = useFetchBeneficiaries({
    grouped: IS_BULK_BENEFICIARY_PAGE,
    singles_only: IS_SINGLE_BENEFICIARY_PAGE
  });

  const openModal = (type) => {
    setModalBeneficiaryModal(type);
  };

  const closeModal = async () => {
    await refetchBeneficiaries();
    setModalBeneficiaryModal(null);
  };
  return (
    <>
      <div className="beneficiaries">
        {canManageBeneficiary && (
          <section className="beneficiaries__intro">
            <h3>Manage Your Beneficiaries</h3>
            <p>
              For Bulk transfers you are required to put together a list of the wallet address and
              amount to be deposited in a CSV file
            </p>
            <div className="beneficiaries__intro__button__group">
              <Button
                variant="dashed"
                size="large"
                onClick={() => {
                  openModal('BULK');
                }}>
                <Add /> Add bulk beneficiaries
              </Button>

              <Button
                variant="dashed"
                size="large"
                onClick={() => {
                  openModal('SINGLE');
                }}>
                <Add /> Add single beneficiary
              </Button>
            </div>
          </section>
        )}
        {IS_SINGLE_BENEFICIARY_PAGE && <SingleBeneficiaries />}
        {IS_BULK_BENEFICIARY_PAGE && <BulkBeneficiaries />}
        {IS_SINGLE_BENEFICIARY && <SingleBeneficiaryModal onModalClose={closeModal} />}
        {IS_BULK_BENEFICIARY && <BulkBeneficiaryModal onModalClose={closeModal} />}
      </div>
    </>
  );
}

export { BeneficiariesSettingsPage };
